import {_serializeSingle, _serializeList} from './core';
import type {ServerData, ServerRecord} from './core';
import type {SerializedWithRaw} from './core';
import type {DomainOf} from '../../../types/domain';
import {serializeUser} from './user';
import type {WithLabels, WithLabelKey} from './_extras';

/** 스키마 밖에서 조립되는 관계 필드 — 서버 응답 계약의 일부. */
type MemberBffExtras = WithLabels & WithLabelKey & {
    departments?: unknown[];
};

// Member
export function serializeMember(data: ServerData) {
    return _serializeSingle("member", data);
}

export function serializeMemberList(data: ServerData) {
    return _serializeList("member", data);
}

// Member BFF (서버: MemberSagaInternalWebResponse)
// 서버 필드: id, externalId, externalStateId, externalStateName, externalUpdatedDate, number, name, email, phone, cellPhone, address, birthDate, joinDate, quitDate, profileUrl, role, state, userId, workspaceId, createdDate, updatedDate, user, departments, labels
export function serializeMemberBff(data: ServerData) {
    if (!data) return null;

    // member 도메인 + user 도메인 병합 + 관계 필드 — 세 층이 한 객체에 합쳐진다
    const member: DomainOf<"member"> & Partial<DomainOf<"user">> & MemberBffExtras = {
        ..._serializeSingle("member", data),
        ...serializeUser(data.user),
    } as DomainOf<"member"> & Partial<DomainOf<"user">> & MemberBffExtras;

    if (data.departments) {
        member.departments = _serializeList("department", data.departments);
    }
    if (data.labels) {
        const labels = _serializeList("label", data.labels);
        member.labels = labels;

        // label.MEMBER_* 설정 (라벨 객체 전체 저장)
        const memberLabelTypes = ['MEMBER_TYPE', 'MEMBER_POSITION', 'MEMBER_RESPONSIBILITY', 'MEMBER_RANK'];
        memberLabelTypes.forEach(type => {
            const label = labels.find((l: ServerRecord) => l['label.type'] === type);
            if (label) {
                member[`label.${type}`] = label;
            }
        });
    }
    return member;
}

export function serializeMemberBffList(data: ServerData) {
    if (!data || !Array.isArray(data)) return [];
    return data.map(item => serializeMemberBff(item));
}

// Department
export function serializeDepartment(data: ServerData) {
    return _serializeSingle("department", data);
}

export function serializeDepartmentList(data: ServerData) {
    return _serializeList("department", data);
}

// Label
export function serializeLabel(data: ServerData) {
    return _serializeSingle("label", data);
}

export function serializeLabelList(data: ServerData) {
    return _serializeList("label", data);
}

// Deleted Participant
export function serializeDeletedParticipant(data: ServerData): SerializedWithRaw<"deletedParticipant"> | null {
    if (!data) return null;
    return {
        ...data,
        ..._serializeSingle("deletedParticipant", data),
    };
}

export function serializeDeletedParticipantList(data: ServerData) {
    return _serializeList("deletedParticipant", data);
}
